import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CircleCheck, X } from "lucide-react";

const MultiPurpose = ({
  title = "Notice",
  message = "",
  yesText = "YES",
  noText = "NO",
  onYes,
  onNo,
  showYesLink = false,
  yesLink = "",
  showNoLink = false,
  noLink = "",
  onClose,
  hideNo = false,
  useHTML = false,
  variant = "",
  children,
  className = "",
}) => {
  const navigate = useNavigate();
  const modalRef = useRef(null);

  const isSuccess = variant === "success";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        if (onClose) {
          onClose();
        } else if (yesLink) {
          if (yesLink.startsWith("http://") || yesLink.startsWith("https://")) {
            window.location.href = yesLink;
          } else {
            navigate(yesLink);
          }
        }
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="as-multipurpose">
      <div className="as-multipurpose-content" ref={modalRef}>
        <div
          className={`as-multipurpose-title-container ${className}`}
        >
          <div className="as-multipurpose-title">
            <strong>{title}</strong>
          </div>
          <button
            className="as-mp-close-button"
            onClick={() => {
              if (onClose) {
                onClose();
                return;
              }
              if (onNo) onNo();
              const target = noLink || yesLink || "/allorder";
              if (
                target.startsWith("http://") ||
                target.startsWith("https://")
              ) {
                window.location.href = target;
              } else {
                navigate(target);
              }
            }}
          >
            <X />
          </button>
        </div>

        {isSuccess && (
          <div className="as-mp-success-icon">
            <div className={`as-mp-success-badge ${className}`}>
              <CircleCheck size={32} />
            </div>
          </div>
        )}

        <div
          className="as-multipurpose-main"
          style={isSuccess ? { paddingTop: "16px" } : undefined}
        >
          {children ? (
            children
          ) : useHTML ? (
            <div dangerouslySetInnerHTML={{ __html: message }} />
          ) : (
            message
          )}
        </div>

        <div className="as-multipurpose-sub">
          {showNoLink ? (
            <button
              className="as-multipurpose-no"
              onClick={() => {
                if (onNo) onNo();
                if (onClose) {
                  onClose();
                  return;
                }
                const target = noLink || yesLink || "/allorder";
                if (
                  target.startsWith("http://") ||
                  target.startsWith("https://")
                ) {
                  window.location.href = target;
                } else {
                  navigate(target);
                }
              }}
            >
              {noText}
            </button>
          ) : (
            !hideNo && (
              <button className="as-multipurpose-no" onClick={onNo}>
                {noText}
              </button>
            )
          )}
          {showYesLink ? (
            <button
              className={`as-multipurpose-yes ${className}`}
              onClick={() => {
                if (onYes) onYes();
                if (onClose) {
                  onClose();
                  return;
                }
                const target = yesLink || noLink || "/allorder";
                if (
                  target.startsWith("http://") ||
                  target.startsWith("https://")
                ) {
                  window.location.href = target;
                } else {
                  navigate(target);
                }
              }}
            >
              {yesText}
            </button>
          ) : (
            <button
              className={`as-multipurpose-yes ${className}`}
              onClick={onYes}
            >
              {yesText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MultiPurpose;
